import Backbone from 'backbone';
import Tools from '../../../../services/Tools';
const MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);

module.exports = Backbone.View.extend({
  tagName: 'div',

  template() {
    const { model } = this;
    const type = model.get('type');
    const read = model.get('read');
    const avatar = model.get('avatar');
    const time = model.get('time');
    const color_text = model.get('color_text');
    const bg_color = model.get('bg_color');
    const showAvatar = model.get('showAvatar');
    const showTime = model.get('showTime');
    const attachments = model.get('attachments');
    const avata_deful = `${model.get('domain')}img/default.png`;
    const mid = model.get('mid');
    const message = model.get('message');
    const date = model.get('date');
    const showDate = model.get('showDate');
    const status = model.get('status');
    return `
              ${
                showDate ? `<div class='lw-date-divider'> <div class="lw-divider"></div> <div class="lw-divider-date mf" ${md.mobile ? `style="font-size: 14px !important;"` : ``}>${date}</div> <div class="lw-divider"></div> </div>` : ''
              }
                ${type !== 1 
                    ? `<div class="avatar">  ${ showAvatar ? `<img src="${Tools.getFavicon() || avata_deful}" />` : '' } </div>`
                    : ''
                }
                <div class="message-inner ${type === 1 ? 'message-user' : 'message-supporter'}">
                    <div class="message-content">
                      ${
                        status === 1 ? `<div class="tiny-loader loader"></div>` : ''
                      }
                      ${attachments && (attachments.type == 'image' || attachments.type == 'IMAGE')
                          ? `<div class='view_file'>
                            ${
                              attachments.link ? 
                                `<a href="${attachments.link}" target="_blank">
                                  <img src="${attachments.link}" width="220px" />
                                </a> ` : ''
                            }
                            ${
                              attachments.image ? `<img src="${attachments.image}" width="220px"></img>` : ''
                            }
                            </div>`
                          : ''
                      }

                      ${
                        attachments && (attachments.type == 'file' || attachments.type == 'FILE' || attachments.type == 'VIDEO') && status === 1 ?
                        ` <div class="message" style="color:${color_text};background-color: ${bg_color}" >
                            <div style="color:${color_text}" >${attachments.name}</div>
                          </div> 
                        ` 
                        : '' 
                      }

                      ${
                        attachments && (attachments.type == 'file' || attachments.type == 'FILE') && status !== 1 ? 
                          Tools.validateAudio(attachments.link)
                            ? `<audio style="width:220px" controls>
                              <source src="${attachments.link}" type="audio/mpeg">
                            </audio>`
                            : `<div class="message" style="color:${color_text};background-color: ${bg_color}" >
                                <a style="color:${color_text};" href="${attachments.link}" target="_blank" download>
                                  <div style="color:${color_text}" class="mf" >${attachments.name}</div>
                                </a>
                              </div>`
                          : ''
                      }

                      ${
                        attachments && attachments.type == 'VIDEO' && status !== 1
                          ? `<video 
                              poster="${model.get(
                                'domain'
                              )}img/video_poster.jpg"
                              webkit-playsinline="true"
                              style="background-color: black;"
                              width="220px" controls="true">
                              <source src="${
                                attachments.link
                              }" type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'>
                            </video>`
                          : ''
                      }

                      ${
                        message
                          ? `<div class="message mf" style="color:${color_text};background-color: ${bg_color}" >
                                ${
                                  Tools.validateLink(message)
                                    ? `<a style="color:${color_text};" href="${message}" target="_blank">${message}</a>`
                                    : Tools.message(message)
                                } 
                          </div>`
                          : ''
                      }
                    </div>
                    ${
                      showTime ? ` <div class="${ type === 1 ? 'time-user' : 'time-supporter'} ${mid} mf" ${md.mobile ? `style="font-size: 14px !important;"` : ``}> ${time} </div>` : ''
                    }
                  </div>`;
  },

  initialize(o) {
    _.bindAll(this, 'renderContent', 'handleShowTimeChange');
    const model = this.model;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
    // this.listenTo(model, 'change', this.renderContent);
  },

  renderContent() {
    const { model, $el } = this;
    const collection = model.collection;
    const currentIndex = collection.indexOf(model);
    const prevModel = currentIndex > 0 && collection.at(currentIndex - 1);
    const nextModel = collection.at(currentIndex + 1);

    // check show avatar
    if (
      prevModel &&
      prevModel.get('type') !== 1 &&
      model.attributes.sender_id === prevModel.attributes.sender_id
    ) {
      model.set('showAvatar', false);
    }

    // check show date
    if (prevModel && prevModel.get('date') !== model.get('date')) {
      model.set('showDate', true);
      prevModel.set('showTime', true);
    }

    // check show time
    if (nextModel && model.attributes.sender_id === nextModel.attributes.sender_id) {
      model.set('showTime', false);
    } else {
      model.set('showTime', true);
    }

    if (!model.get('showDate') && prevModel &&  model.attributes.sender_id === prevModel.attributes.sender_id && prevModel.get('showTime')) {
        prevModel.set('showTime', false);
    }

    this.$el.html(this.template());
  },

  handleShowTimeChange() {
    this.$el.html(this.template());
  },

  handleStatusChange() {
    this.$el.html(this.template());
  },

  render() {
    const { $el, pfx, model } = this;
    $el.attr('class', 'message-item');
    this.renderContent();
    // listen events
    this.listenTo(model, 'change:showTime', this.handleShowTimeChange);
    this.listenTo(model, 'change:status', this.handleStatusChange);
    
    return this;
  }
});
